export function followPost(
  container: HTMLElement,
  requestedPost: () => Element | undefined,
): () => void {
  const events = new AbortController();
  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const post = requestedPost();
      if (post && !document.querySelector("dialog[open]")) {
        scrollBy({
          top: post.getBoundingClientRect().top - 12,
          behavior: "instant",
        });
      }
    });
  };
  const mutations = new MutationObserver(schedule);
  mutations.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  });
  const sizes = new ResizeObserver(schedule);
  sizes.observe(container);

  const stop = () => {
    events.abort();
    mutations.disconnect();
    sizes.disconnect();
    cancelAnimationFrame(frame);
  };
  const options = { signal: events.signal, passive: true };
  addEventListener("wheel", stop, options);
  addEventListener("touchmove", stop, options);
  addEventListener("pointerdown", (event) => {
    if (
      event.button === 1 ||
      event.clientX >= document.documentElement.clientWidth
    ) stop();
  }, options);
  addEventListener("keydown", (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest("input, textarea, select, [contenteditable]")
    ) return;
    if (
      ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "]
        .includes(
          event.key,
        )
    ) stop();
  }, options);
  schedule();
  return stop;
}
